import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const TarifeHeader = React.lazy(() => import("./sections/TarifeHeader"));
const OfferRequestForm = React.lazy(() => import("./sections/OfferRequestForm"));
const TarifeList = React.lazy(() => import("./sections/TarifeList"));

function Tarife() {
    const canonicalUrl = "https://doral-cleaning.ro/tarife/";

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Helmet>
                <title>Tarife Curățenie | Prețuri Servicii Doral Cleaning</title>
                <link rel="canonical" href={canonicalUrl} />
                <meta
                    name="description"
                    content="Solicită o ofertă personalizată pentru curățenie generală, întreținere, postconstructor sau servicii speciale. Valoarea minimă a deplasării este de 500 lei."
                />
            </Helmet>
            <TarifeHeader />

            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Container sx={{ py: { xs: 5, md: 8 } }}>
                    <MKBox textAlign="center" maxWidth={760} mx="auto" mb={{ xs: 4, md: 6 }}>
                        <MKTypography variant="h2" color="dark" mb={2} sx={{ textWrap: "balance" }}>
                            Spune-ne de ce ai nevoie
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                            Completează detaliile de mai jos, iar echipa noastră îți va pregăti o
                            ofertă adaptată spațiului și serviciilor solicitate.
                        </MKTypography>
                        <MKBox
                            sx={{
                                backgroundColor: "#eef6ff",
                                borderLeft: "4px solid #1a73e8",
                                p: 2,
                                borderRadius: "0 8px 8px 0",
                                textAlign: "left",
                            }}
                        >
                            <MKTypography variant="body2" color="dark" fontWeight="medium">
                                <strong>Notă importantă:</strong> Valoarea minimă a unei deplasări
                                (comanda minimă pentru intervenție) este de <strong>500 de lei</strong>.
                                Deplasarea pentru evaluarea inițială a spațiului este gratuită în
                                București și Ilfov.
                            </MKTypography>
                        </MKBox>
                    </MKBox>
                    <OfferRequestForm />

                    <Divider sx={{ my: { xs: 7, md: 10 } }} />

                    <MKBox textAlign="center" maxWidth={760} mx="auto" mb={{ xs: 4, md: 6 }}>
                        <MKTypography variant="h2" color="dark" mb={2} sx={{ textWrap: "balance" }}>
                            Alege serviciul potrivit
                        </MKTypography>
                        <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                            Descoperă toate serviciile Doral Cleaning și accesează pagina dedicată
                            pentru mai multe informații. Comanda minimă pentru deplasare este de{" "}
                            <strong>minimum 500 de lei</strong>.
                        </MKTypography>
                    </MKBox>
                    <TarifeList />
                </Container>
            </Card>
        </Suspense>
    );
}

export default Tarife;
